// extracted by mini-css-extract-plugin
export default {"container":"EmptyList_container__Dp4hS","containerImg":"EmptyList_containerImg__5QYF3","description":"EmptyList_description__UiEAv"};